import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { PORTAL_ROLES, resolvePortalFeatureLock } from '../components/Sidebar/portalNav'

export function usePortalFeatureLock() {
  const { user, role, isAdmin } = useAuth()
  const location = useLocation()

  return useMemo(() => {
    if (isAdmin || !PORTAL_ROLES.includes(role)) {
      return { locked: false, lockType: null, featureKey: null, label: null }
    }
    const searchParams = new URLSearchParams(location.search)
    return resolvePortalFeatureLock(location.pathname, searchParams, role, user)
  }, [isAdmin, role, user, location.pathname, location.search])
}
